module.exports = __webpack_public_path__ + "img/kleisma3.71d7d643.webp";